import { AccountService } from '@one/app/shared/services/account/account.service';
import { AuthenticationService } from '@one/app/shared/services/auth/authentication.service';
import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { QimaButtonModule, EQimaButtonWidth, EQimaButtonSize, QimaButtonLinkModule, EQimaIconName, QimaIconModule } from '@qima/ngx-qima';

@Component({
  selector: 'one-isp-inspection-logback-header',
  templateUrl: './isp-inspection-logback-header.component.html',
  styleUrls: ['./isp-inspection-logback-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [QimaButtonModule, TranslateModule, QimaButtonLinkModule, QimaIconModule],
})
export class IspInspectionLogbackHeaderComponent implements OnInit {
  public readonly qimaButtonSizes = EQimaButtonSize;
  public readonly qimaButtonWidths = EQimaButtonWidth;
  public readonly qimaIconNames = EQimaIconName;

  public canLogBackAsSupervisor: boolean = false;

  public constructor(
    private readonly _authenticationService: AuthenticationService,
    private readonly _accountService: AccountService,
    private readonly _router: Router
  ) {}

  public ngOnInit(): void {
    this.canLogBackAsSupervisor = this._authenticationService.hasRootSessionToken();
  }

  public logBackAsSupervisor(): void {
    this._authenticationService.logBackWithRootSessionToken();
    const returnUrl = this._authenticationService.getBrdReturnUrlAndClear();

    void this._accountService.forceIdentity().then((): Promise<boolean> => {
      if (returnUrl) {
        return this._router.navigateByUrl(returnUrl);
      }

      return this._router.navigate(['/']);
    });
  }
}
